<template>
  <div v-if="totalSteps > 1" class="pe-progress-container">
    <div class="pe-progress-interno">

      <template v-for="index in totalSteps" :key="index">

        <div class="pe-step-wrapper">

          <div class="pe-step-circle" :class="[
            // Usamos currentIndex (0-based) para comparar con index (1-based)
            { 'pe-step-circle--active': index === currentIndex + 1 },
            { 'pe-step-circle--completed': index <= currentIndex },
            globalConfig?.classes?.progressBarCircle
          ]">
            <span v-if="index <= currentIndex" class="pe-step-tick">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M3.87459 12C3.53396 12.0002 3.20728 11.8126 2.96662 11.4787L0.22153 7.67744C-0.0738435 7.26814 -0.0738435 6.60467 0.22153 6.19536C0.516999 5.78619 0.995953 5.78619 1.29142 6.19536L3.87459 9.77374L10.7086 0.306878C11.004 -0.102293 11.483 -0.102293 11.7785 0.306878C12.0738 0.716179 12.0738 1.37966 11.7785 1.78896L4.78256 11.4787C4.5419 11.8126 4.21523 12.0002 3.87459 12Z"
                  fill="currentColor" />
              </svg>
            </span>
            <span v-else>{{ index }}</span>
          </div>

          <span class="pe-step-label" :class="globalConfig?.classes?.progressBarLabel">
            Paso {{ index }}
          </span>
        </div>

        <div v-if="index < totalSteps" class="pe-step-connector"
          :class="{ 'pe-step-connector--filled': index <= currentIndex }"></div>

      </template>

    </div>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';

// 1. Inyectamos Configuración y Motor
const globalConfig = inject('engineConfig');
const engine = inject('formEngine');

// 2. Computamos los datos directamente desde el motor
const totalSteps = computed(() => {
  return engine?.sections?.value?.length || 0;
});

const currentIndex = computed(() => {
  return engine?.currentSectionIndex?.value || 0;
});
</script>

<style scoped>
.pe-progress-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: var(--pe-progress-margin, 0);
}

/* CONTENEDOR INTERNO (Flex Row) */
.pe-progress-interno {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: auto;
  min-width: var(--pe-progress-min-width, 18rem);
}

/* WRAPPER DE CADA PASO (Círculo + Label) */
.pe-step-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  z-index: 1;
  /* Para que quede sobre la línea si se superponen */
  width: var(--pe-progress-circle-size, 28px);
  /* 2. Permitimos que el texto (que es más ancho) se vea igual */
  overflow: visible;
}

/* LABEL "Paso X" */
.pe-step-label {
  /* position: absolute;
  top: 100%; */
  margin-top: var(--pe-progress-bar-lbl-mg-top, 0.5vh);
  white-space: nowrap;

  transition: color 0.4s ease;
}

/* CÍRCULO BASE */
.pe-step-circle {
  width: var(--pe-progress-circle-size, 28px);
  height: var(--pe-progress-circle-size, 28px);
  aspect-ratio: 1/1;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  /* Estilos por defecto (Inactivo) */
  background: var(--pe-progress-bg-inactive, transparent);
  border: var(--pe-progress-bar-border, 4px solid var(--pe-progress-color-inactive, #e0e0e0));
  color: var(--pe-progress-text-inactive, #e0e0e0);

  transition: all 0.4s ease;
}

/* ESTADO: ACTIVO (Paso actual) */
.pe-step-circle--active {
  background: var(--pe-pb-primary-color, #007bff);
  border-color: transparent;
  border: none;
  color: var(--pe-pb-text-active, #ffffff);
  /* transform: scale(1.1); */
  /* Efecto pop sutil */
}

/* ESTADO: COMPLETADO (Pasos anteriores) */
.pe-step-circle--completed {
  background: var(--pe-pb-primary-color, #007bff);
  border: none;
  color: var(--pe-pb-text-active, #ffffff);
}

/* TICK MARK (SVG) */
.pe-step-tick {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* LÍNEA CONECTORA */
.pe-step-connector {
  flex-grow: 1;
  height: var(--pe-progress-line-gross, 4px);
  min-width: var(--pe-progress-line-min-w, 30px);
  max-width: var(--pe-progress-line-max-w, 100px);

  background-color: var(--pe-progress-color-inactive, #e0e0e0);

  margin: var(--pe-progress-line-margin, 0);
  margin-top: calc( (var(--pe-progress-circle-size, 28px) - var(--pe-progress-line-gross, 4px)) / 2 );
  transition: background-color 0.4s ease;
}

/* LÍNEA COMPLETADA */
.pe-step-connector--filled {
  background: var(--pe-pb-primary-color, #007bff);
}

/* RESPONSIVE */
@media (max-width: 600px) {
  .pe-progress-interno {
    min-width: 100%;
    /* Ocupa todo el ancho en móvil */
  }

  .pe-step-label {
    display: none;
    /* Ocultar etiquetas en móvil si hay muchos pasos */
  }

  .pe-step-connector {
    min-width: 10px;
    /* Reducir líneas en móvil */
  }
}
</style>